import { Lobby } from "@lobby/core/src/entities";
import { Button, LanguageSelector, ThemeSwitch, useAuth, useModal } from "@lobby/core/src/shared";
import { useTranslate } from "@lobby/ocb-intl";
import { useNavigate } from "@tanstack/react-router";
import usdtLogoImg from "assets/usdt_logo.png";
import { RegisterForm } from "features/register-form";
import { useEffect } from "react";
import { Logo } from "shared/ui";
import { Modal } from "shared/ui/modal";

export function RegisterModal({ isStatic = false }: { isStatic?: boolean }) {
  const { isOpen, close } = useModal("register");

  return (
    <Modal open={isOpen}>
      <Modal.Overlay onClick={isStatic ? undefined : close} />
      <RegisterModalComponent />
    </Modal>
  );
}

function RegisterModalComponent() {
  const { open: openLogInModal } = useModal("log-in");
  const { $t } = useTranslate();
  const navigate = useNavigate();

  const { isAuth } = useAuth();
  const { data: lobbyData } = Lobby.useLobby();

  const isRegistrationEnabled = lobbyData?.registration.enabled ?? false;

  useEffect(() => {
    if (isAuth || !isRegistrationEnabled) {
      navigate({
        to: "/",
        replace: true,
      });
    }
  }, [isAuth, isRegistrationEnabled, navigate]);

  return (
    <Modal.Panel className="mobile-only:min-h-full w-full border-keppel bg-mercury p-5 lg:top-17 lg:w-[28.75rem] lg:rounded-rounded lg:border-1 dark:border-shark dark:bg-ebony-clay">
      <Logo className="mx-auto h-20 lg:h-24" />
      <div className="mt-5 flex-c-sb gap-5">
        <div className="font-bold text-lg uppercase lg:text-xl">
          {$t({ defaultMessage: "Registration" })}
        </div>
        <Button variant="secondary" onClick={openLogInModal}>
          {$t({ defaultMessage: "sign in" })}
        </Button>
      </div>

      <div className="mt-5 mobile-only:mb-10">
        <RegisterForm />
      </div>

      <div className="w-44 lg:w-52 mx-auto">
        <img src={usdtLogoImg} alt="usdt logo" />
      </div>

      <div className="mt-auto flex items-center justify-between">
        <LanguageSelector orientation="top" />
        <ThemeSwitch />
      </div>
    </Modal.Panel>
  );
}
